import React, {useEffect, useRef, useState} from "react";
import sia from "../services/Api";
import Cookies from "js-cookie";
// import {useLoginDispatch} from "../hooks";
import logo from '../assets/images/logo.svg';
import TopNav from "./TopNav";
import LoaderView from "../tools/LoaderView";
import {notifyError, notifyErrorMessage, notifySuccessful, notifySuccessfulMessage} from "../App";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer, toast, Slide} from 'react-toastify'

function Register(props) {
    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
    }, [])

    const handleRegister = async (e) => {
        setLoading(true)
        e.preventDefault();
        const postBody = {
            "type": "1",
            "name": e.target.elements.fname.value,
            "lname": e.target.elements.lname.value,
            "phone": e.target.elements.phone.value,
            "password": e.target.elements.password.value,
            "password_confirmation": e.target.elements.password_confirmation.value
        };

        console.log(postBody)


        await sia.PostDataToServer("/user/register", postBody)
            .then(res => {
                console.log(res);
                notifySuccessfulMessage('ثبت نام با موفقیت انجام شد')
                props.history.push("/login");

            })
            .catch(err => {
                let errors;
                errors = err.errors
                errors.map((item, index) => notifyErrorMessage(item[0]))
            })
        setLoading(false)
    }
    return (
        <>
            <ToastContainer rtl closeOnClick pauseOnHover position="top-center" transition={Slide}/>
            <div className="pagewrapper" id="login-page">
                <div className="blur">
                    <div className="container">
                        <TopNav/>
                        <div className="content">
                            {isLoading ? <LoaderView/> : <div className="login-wrapper radius50 box-sizing">
                                <form action id="login-form" method="post" onSubmit={handleRegister}>
                                    <p className="text">فرم زیر را برای ثبت نام در نکویاد پر کنید:</p>
                                    <div className="input-wrapper">
                                        <input type="text" name="fname"
                                               className="login-fname input radius50 box-sizing"/>
                                        <label className="label radius50 box-sizing">نام</label>
                                    </div>
                                    <div className="input-wrapper">
                                        <input type="text" name="lname"
                                               className="login-lname input radius50 box-sizing"/>
                                        <label className="label radius50 box-sizing">نام خانوادگی</label>
                                    </div>
                                    <div className="input-wrapper">
                                        <input type="phone" name="phone"
                                               className="login-phone input radius50 box-sizing"/>
                                        <label className="label radius50 box-sizing">تلفن همراه</label>
                                    </div>
                                    <div className="input-wrapper">
                                        <input type="password" name="password"
                                               className="login-pswrd input radius50 box-sizing"/>
                                        <label className="label radius50 box-sizing">رمز ورود</label>
                                    </div>
                                    <div className="input-wrapper">
                                        <input type="password" name="password_confirmation"
                                               className="login-pswrd-conf input radius50 box-sizing"/>
                                        <label className="label radius50 box-sizing">تکرار رمز ورود</label>
                                    </div>
                                    <input type="submit" value="ثبت نام" className="login-btn radius50"/>
                                    <p onClick={() => window.location = './login'} className="clickable pt-3">حساب
                                        کاربری دارید؟</p>
                                </form>
                            </div>}
                        </div>
                        <div className="top-section-bullets">
                            <a href title className="item ease box-sizing"/>
                            <a href title className="item selected ease box-sizing"/>
                            <a href title className="item ease box-sizing"/>
                            <a href title className="item ease box-sizing"/>
                        </div>
                        <div className="clear"/>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Register
